import { motion } from "framer-motion";
import {
  Clock,
  Wrench,
  Zap,
  ShieldCheck,
  Receipt,
  MapPinned,
  CreditCard,
  BadgeCheck,
} from "lucide-react";

const ITEMS = [
  {
    icon: Clock,
    title: "Atendimento 24 Horas",
    desc: "Madrugada, feriado, chuva. Nunca fechamos.",
    span: "sm:col-span-2 sm:row-span-2",
    big: true,
  },
  {
    icon: Wrench,
    title: "Equipe especializada",
    desc: "Motoristas treinados em amarração e resgate.",
  },
  {
    icon: Zap,
    title: "Chegada rápida",
    desc: "Frota estrategicamente distribuída na região.",
  },
  {
    icon: ShieldCheck,
    title: "Segurança total",
    desc: "Plataforma com trava, cintas e proteção.",
  },
  {
    icon: Receipt,
    title: "Orçamento transparente",
    desc: "Valor fechado antes do serviço iniciar.",
  },
  {
    icon: MapPinned,
    title: "Residencial e rodovias",
    desc: "Atendemos garagem, rua e BR-316 / BR-010.",
  },
  {
    icon: CreditCard,
    title: "Pix, cartão e dinheiro",
    desc: "Pagamento fácil no momento do serviço.",
  },
];

export default function Diferenciais() {
  return (
    <section
      id="diferenciais"
      data-testid="diferenciais-section"
      className="relative bg-black py-24 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-12 gap-6 border-b border-chrome/15 pb-10">
          <div className="col-span-12 flex items-center gap-4 sm:col-span-4">
            <span className="font-mono text-xs tracking-[0.3em] text-brand-yellow">
              [ SEÇÃO 02 ]
            </span>
            <span className="h-px flex-1 bg-chrome/20" />
          </div>
          <h2
            data-testid="diferenciais-h2"
            className="col-span-12 font-display text-5xl uppercase leading-[0.9] tracking-tight text-white sm:col-span-8 sm:text-7xl"
          >
            Por que a <br />
            <span className="text-brand-yellow">Gorillas</span>?
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden border border-chrome/15 bg-chrome/15 sm:grid-cols-4">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.6,
                  ease: [0.22, 1, 0.36, 1],
                  delay: i * 0.05,
                }}
                className={`group relative flex flex-col justify-between bg-brand-black p-6 transition-colors hover:bg-neutral-950 sm:p-8 ${
                  it.span || ""
                } ${it.big ? "min-h-[340px]" : "min-h-[220px]"}`}
                data-testid={`diferencial-${i}`}
              >
                <div className="flex items-start justify-between">
                  <Icon
                    className={`transition-colors group-hover:text-brand-yellow ${
                      it.big ? "h-10 w-10 text-brand-yellow" : "h-6 w-6 text-chrome"
                    }`}
                    strokeWidth={1.5}
                  />
                  <span className="font-mono text-[10px] tracking-[0.3em] text-neutral-600">
                    0{i + 1}
                  </span>
                </div>
                <div>
                  <h3
                    className={`font-display uppercase leading-tight tracking-tight text-white ${
                      it.big ? "text-4xl sm:text-5xl" : "text-xl sm:text-2xl"
                    }`}
                  >
                    {it.title}
                  </h3>
                  <p className="mt-2 max-w-xs font-body text-sm text-neutral-400">
                    {it.desc}
                  </p>
                </div>
                <BadgeCheck className="pointer-events-none absolute -bottom-3 -right-3 h-16 w-16 text-brand-yellow/5 transition-transform group-hover:scale-110 group-hover:text-brand-yellow/10" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
